export default __webpack_public_path__ + "static/media/duck_grayscale.dd20c860.svg";